/**
 * React Query hooks for board-meeting records on the investor portal.
 *
 * Refetch is gentle (5 min) — meeting records are append-only and a
 * shareholder leaving a tab open shouldn't spam the API. The detail
 * query stales out after 5 min too; if the board republishes a meeting
 * (rare), the user gets the new minutes on next tab focus.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchBoardMeeting, fetchBoardMeetings } from '@/api/meetings';

export const useBoardMeetings = () =>
  useQuery({
    queryKey: ['boardMeetings'],
    queryFn: fetchBoardMeetings,
    refetchInterval: 5 * 60_000,
    staleTime: 60_000
  });

export const useBoardMeeting = (id: string | undefined) =>
  useQuery({
    queryKey: ['boardMeeting', id],
    queryFn: () => fetchBoardMeeting(id as string),
    enabled: !!id,
    staleTime: 5 * 60_000
  });
